export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/',
  LOCATIONS: '/locations',
  LOCATION_DETAIL: (id: string) => `/locations/${id}`,
  EQUIPMENT: '/equipment', // Deprecated - kept for backward compatibility
  INVENTORY_CATALOG: '/inventory/catalog', // Deprecated - use INVENTORY_MANAGEMENT
  INVENTORY_RESERVES: '/inventory/reserves', // Deprecated - use INVENTORY_MANAGEMENT
  INVENTORY_SERIAL_SEARCH: '/inventory/serial-search', // Deprecated - use INVENTORY_MANAGEMENT
  INVENTORY_MANAGEMENT: '/inventory',
  UPCOMING_ORDERS: '/orders/upcoming', // Deprecated - use UPCOMING_LAUNCHES
  UPCOMING_LAUNCHES: '/launches/upcoming',
  PRODUCTS_PRICING: '/products-pricing',
  FULFILLMENT_DASHBOARD: '/dashboard/fulfillment',
  SHIPMENTS: '/shipments',
  SHIPMENT_DETAIL: (id: string) => `/shipments/${id}`,
  PACKING_SLIP_DETAIL: (id: string) => `/packing-slips/${id}`,
  PURCHASE_ORDER_DETAIL: (id: string) => `/purchase-orders/${id}`,
  PURCHASE_ORDERS: '/purchase-orders',
  CONTACTS: '/contacts',
  SETTINGS: '/settings',
  REPORTING: '/reporting',
  EMAIL_INSIGHTS: '/email-insights',
  NETWORK_PULSE: '/network-pulse',
  NETWORK_PULSE_REPORTS: '/network-pulse/reports',
  NETWORK_PULSE_CAMPAIGN_REPORT_PATTERN: '/network-pulse/reports/:campaignId',
  NETWORK_PULSE_CAMPAIGN_REPORT: (campaignId: string) =>
    `/network-pulse/reports/${encodeURIComponent(campaignId)}`,
  STORE_PULSE_ALERTS: '/store-pulse-alerts',
  V2_STATUS: '/v2-status',
  V2_STATUS_SHARE: '/v2-status/share',
  DEALS: '/deals',
  DEMO_FOLLOW_UP_PACKET: '/deals/follow-up-packet',
  LEADS: '/leads',
  LEADS_BLUEPRINT_TAB: '/leads?tab=blueprint',
  BLUEPRINT_LEADS: '/blueprint-leads',
  BLUEPRINT_LEAD_DETAIL: (id: string) => `/blueprint-leads/${id}`,
  SALES_BILLING: '/sales-billing',
  SLA_AGREEMENTS: '/sla-agreements',
  SLA_AGREEMENT_DETAIL: (id: string) => `/sla-agreements/${id}`,
  SLA_AGREEMENT_SIGN: (token: string) => `/sign/license-agreement/${token}`,
  CASHFLOW: '/cashflow',
  CASHFLOW_STATEMENT: '/cashflow/statement',
  QUOTE_FORM: (id?: string) => id ? `/sales-billing/quotes/${id}/edit` : '/sales-billing/quotes/new',
  QUOTE_DETAIL: (id: string) => `/sales-billing/quotes/${id}`,
  INVOICE_FORM: (id?: string) => id ? `/sales-billing/invoices/${id}/edit` : '/sales-billing/invoices/new',
  INVOICE_DETAIL: (id: string) => `/sales-billing/invoices/${id}`,
  CUSTOMER_OPS: '/customer-ops',
  CUSTOMER_OPS_PROOF: '/customer-ops/proof',
  CUSTOMER_OPS_PROOF_NEW: '/customer-ops/proof/new',
  CUSTOMER_OPS_PROOF_DETAIL: (proofMetricId: string) => `/customer-ops/proof/${proofMetricId}`,
  CUSTOMER_OPS_PROOF_REVIEW: (runId: string) => `/customer-ops/proof/review/${runId}`,
  CUSTOMER_OPS_REVIEW_DUE: '/customer-ops/review-due',
  CUSTOMER_OPS_REVIEW_DUE_DETAIL: (id: string) => `/customer-ops/review-due/${id}`,
  CUSTOMER_OPS_AT_RISK: '/customer-ops/at-risk',
  CUSTOMER_OPS_AT_RISK_DETAIL: (id: string) => `/customer-ops/at-risk/${id}`,
  CUSTOMER_OPS_CONTENT: '/customer-ops/content',
  CUSTOMER_OPS_CONTENT_DETAIL: (id: string) => `/customer-ops/content/${id}`,
  CUSTOMER_OPS_PLACEMENT_AUDITS: '/customer-ops/placement-audits',
  CUSTOMER_OPS_PLACEMENT_AUDIT_DETAIL: (id: string) => `/customer-ops/placement-audits/${id}`,
  /** @deprecated Network Pulse moved to ROUTES.NETWORK_PULSE; kept only so old bookmarks/links redirect. */
  CUSTOMER_OPS_NETWORK_PULSE: '/customer-ops/network-pulse',
  CUSTOMER_OPS_USER_ACCESS_REVIEWS: '/customer-ops/user-access-reviews',
  CUSTOMER_OPS_USER_ACCESS_REVIEW: '/customer-ops/user-access-review',
  CUSTOMER_OPS_USER_ACCESS_REVIEW_DETAIL: (token: string) => `/customer-ops/user-access-review/${token}`,
} as const;
